import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { rosterApi } from "./roster-api";
import rosterReducer from "./roster-slice";

export const createRosterStore = () => {
	const store = configureStore({
		reducer: {
			roster: rosterReducer,
			[rosterApi.reducerPath]: rosterApi.reducer,
		},
		middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(rosterApi.middleware),
	});

	setupListeners(store.dispatch);

	return store;
};

export type RosterStore = ReturnType<typeof createRosterStore>;
export type RootState = ReturnType<RosterStore["getState"]>;
export type AppDispatch = RosterStore["dispatch"];
